const  breakPoint = 768;
let resizeFlag    = false
let windowWidth   = window.innerWidth;
let windowHeight  = window.innerHeight;
let windowWidthJQ = $(window).width();

const setSlider = () => {
  let sliderImageWidth;
  let sliderExtraWidth;
  let sliderShowNumber;
  let sliderInitialSlide;
  let sliderObject;
  if (windowWidthJQ > breakPoint) {
    sliderImageWidth   = 1060;
    sliderExtraWidth   = (windowWidthJQ - sliderImageWidth) / 2;
    sliderShowNumber   = 2;
    sliderInitialSlide = 0;
  } else {
    sliderImageWidth   = windowWidthJQ * 0.8325;
    sliderExtraWidth   = (windowWidthJQ - sliderImageWidth) / 2;
    sliderShowNumber   = 1;
    sliderInitialSlide = 4;
  }
  sliderObject = $('#indexSlider').slick({
    speed: 425,
    autoplay: true,
    autoplaySpeed: 3250,
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: sliderShowNumber,
    initialSlide: sliderInitialSlide,
    centerMode: true,
    centerPadding: sliderExtraWidth + 'px',
    cssEase: 'cubic-bezier(.5,.15,.25,1)'
  });
  $(window).on('load', function() {
    $('#indexSlider').addClass('is-Loaded');
  });
  $(window).on('resize' , function() {
   let resizeWidhJQ = $(window).width();
   let sliderResizeWidth;
   let sliderResizeExtraWidth;
   let sliderResizeShowNumber;
   let sliderResizeInitialSlide;
   if (resizeWidhJQ > breakPoint) {
     sliderResizeWidth        = 1060;
     sliderResizeExtraWidth   = (resizeWidhJQ - sliderResizeWidth) / 2;
     sliderResizeShowNumber   = 2;
     sliderResizeInitialSlide = 0;
   } else {
     sliderResizeWidth        = resizeWidhJQ * 0.8325;
     sliderResizeExtraWidth   = (resizeWidhJQ - sliderResizeWidth) / 2;
     sliderResizeShowNumber   = 1;
     sliderResizeInitialSlide = 4;
   }
   sliderObject[0].slick.options.centerPadding = sliderResizeExtraWidth + 'px';
   sliderObject[0].slick.options.slidesToShow  = sliderResizeShowNumber;
   sliderObject[0].slick.options.initialSlide  = sliderResizeInitialSlide;
 });
};
setSlider();

import { loadFonts } from "../include/module";
loadFonts();

import { detectionScroll } from "../include/module";
detectionScroll();

import { switchHeader } from "../include/module";
switchHeader();

import { switchServices } from "../include/module";
switchServices();

import { tilePost } from "../include/module";
tilePost();

import { anchorScroll } from "../include/module";
anchorScroll();



// WEBPACK FOOTER //
// script.js